var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 10.7337V9.267C1.6665 8.40033 2.37484 7.68367 3.24984 7.68367C4.75817 7.68367 5.37484 6.617 4.6165 5.30867C4.18317 4.55867 4.4415 3.58367 5.19984 3.15033L6.6415 2.32533C7.29984 1.93367 8.14984 2.167 8.5415 2.82533L8.63317 2.98367C9.38317 4.292 10.6165 4.292 11.3748 2.98367L11.4665 2.82533C11.8582 2.167 12.7082 1.93367 13.3665 2.32533L14.8082 3.15033C15.5665 3.58367 15.8248 4.55867 15.3915 5.30867C14.6332 6.617 15.2498 7.68367 16.7582 7.68367C17.6248 7.68367 18.3415 8.392 18.3415 9.267V10.7337C18.3415 11.6003 17.6332 12.317 16.7582 12.317C15.2498 12.317 14.6332 13.3837 15.3915 14.692C15.8248 15.4503 15.5665 16.417 14.8082 16.8503L13.3665 17.6753C12.7082 18.067 11.8582 17.8337 11.4665 17.1753L11.3748 17.017C10.6248 15.7087 9.3915 15.7087 8.63317 17.017L8.5415 17.1753C8.14984 17.8337 7.29984 18.067 6.6415 17.6753L5.19984 16.8503C4.4415 16.417 4.18317 15.442 4.6165 14.692C5.37484 13.3837 4.75817 12.317 3.24984 12.317C2.37484 12.317 1.6665 11.6003 1.6665 10.7337Z",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.58cc22fec45a5e493e87b1650e5a9ddf.svg";
export { ForwardRef as ReactComponent };